import { Flex, Text, useDisclosure } from '@chakra-ui/react';

import PasswordResetFormModal from './PasswordResetFormModal';
import { useTranslation } from 'react-i18next';

export default function PasswordResetForm() {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text variant="formSectionHeading">{t('learners.profile.settings.password.title')}</Text>

        <Text
          fontSize="14px"
          fontWeight={500}
          color="brand.button"
          _hover={{ cursor: 'pointer' }}
          onClick={onOpen}
        >
          {t('learners.profile.settings.password.change')}
        </Text>
      </Flex>

      <PasswordResetFormModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
